import React, { useEffect, useState, useContext } from "react";
import { toast } from "react-toastify";
import axios from "../../../../../Axios/Axios";
import { Urls } from "../../../../../Urls";
import { sendMailToMasters } from "../../Utility/utility";
import { useMixPanelForTracking } from "../../../../../utils/TrackMixPanel";
import { UserApiContext } from "../../../../UserDetailsContext/UserDetailsContext";
import { MyCompanyProfileContext } from "../../../../../../src/MyCompanyProfileContext";

const convertToTon = ["mt", "ton"];

/**
 * TruckDetails Component
 * Displays and manages truck details after file upload.
 * @param {number} step - Current step in the process
 * @param {React.SetStateAction} setStep - Function to update the current step
 * @param {Array} uploadedData - Data uploaded from the file
 * @param {React.SetStateAction} setUploadedData - Function to update uploaded data
 * @param {Array} truckMasterList - List of truck masters
 * @param {React.SetStateAction} setTruckMasterList - Function to update truck master list
 * @param {string} companyId - ID of the company
 * @returns {JSX.Element}
 */
const TruckDetails = ({ uploadedData, setTruckMasterList, companyId, superAdmins, emailTemplate }) => {
  const [truckData, setTruckData] = useState([]);
  const { userDetails } = useContext(UserApiContext);
  const { companySettingData } = useContext(MyCompanyProfileContext);
  const { TrackMixPanel } = useMixPanelForTracking(userDetails, companySettingData);

  // useeffect that sets the volume for each truck if not provided
  useEffect(() => {
    if (uploadedData && uploadedData.length > 0) {
      const processedData = uploadedData.map((data) => ({
        ...data,
        Volume: calculateVolume(data),
      }));
      setTruckData(processedData);
    }
  }, [uploadedData]);

  const calculateVolume = (data) => {
    if (data["Volume"]) return data["Volume"];
    if (data["Length*"] && data["Breadth*"] && data["Height*"]) {
      return parseInt(data["Length*"] * data["Breadth*"] * data["Height*"]);
    }
    return "";
  };

  /**
   * Saves the truck details.
   * @param {Array} truck_details - Truck details to be saved
   */
  const saveDetails = () => {
    const payload = truckData.map((details) => ({
      truck_category: String(details["Truck Category*"]).trim(),
      truck_type: String(details["Truck Type*"]).trim(),
      truck_name: String(details["Truck Name"] ? details["Truck Name"] : details["Truck Type*"]).trim(),
      dimensions: {
        length: parseFloat(details["Length*"]) || 0,
        breadth: parseFloat(details["Breadth*"]) || 0,
        height: parseFloat(details["Height*"]) || 0,
        volume: parseFloat(details["Volume"]) || 0,
      },
      weight: parseFloat(details["Weight*"]) || 0,
      unit: convertToTon.includes(String(details["Weight Unit*"]).trim().toLowerCase()) ? "TON" : "KG",
    }));

    if (payload.length > 0) {
      TrackMixPanel({
        ModuleName: "masters",
        ScreenName: "truck master",
        Definition: "user clicked on truck master upload confirm and submit button",
        Data: JSON.stringify({ truck_count: payload.length }),
      });
      axios
        .post(`${Urls.companyProfile}?company_id=${companyId}&truck_master=add`, { data: payload })
        .then((res) => {
          TrackMixPanel({
            ModuleName: "masters",
            ScreenName: "truck master",
            Definition: "truck master upload successful",
            Data: JSON.stringify({ truck_count: payload.length }),
          });

          sendMailToMasters(
            "Truck Master",
            emailTemplate,
            superAdmins,
            { action: "New File Uploaded", lane: "" },
            () => { },
            userDetails?.user_name || userDetails?.email?.split("@")[0]
          );

          setTruckMasterList(res.data[0].truck_details);
          toast.success("Data Added Successfully");
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    }
  };

  return (
    <div className="container-fluid mt-4">
      <div
        className="table-responsive"
        style={{ maxHeight: "60vh", overflow: "auto" }}
      >
        <table className="table table-striped table-bordered">
          <thead className="thead-light sticky-top">
            <tr>
              <th scope="col" className="text-center">
                Sr No.
              </th>
              <th scope="col" className="text-center">
                Truck Category
              </th>
              <th scope="col" className="text-center">
                Truck Name
              </th>
              <th scope="col" className="text-center">
                Dimensions (l x b x h)
              </th>
              <th scope="col" className="text-center">
                Volume
              </th>
              <th scope="col" className="text-center">
                Weight
              </th>
              <th scope="col" className="text-center">
                Weight Unit
              </th>
            </tr>
          </thead>
          <tbody>
            {truckData &&
              truckData.map((data, index) => (
                <tr key={index}>
                  <td className="text-center">{index + 1}</td>
                  <td className="text-center">{data["Truck Category*"]}</td>
                  <td className="text-center">{data["Truck Name"] || data["Truck Type*"] || "-"}</td>
                  <td className="text-center">
                    {`${data["Length*"] || ""} x ${data["Breadth*"] || ""} x ${data["Height*"] || ""
                      }`}
                  </td>
                  <td className="text-center">{data["Volume"]}</td>
                  <td className="text-center">{data["Weight*"]}</td>
                  <td className="text-center">{convertToTon.includes(String(data["Weight Unit*"]).trim().toLowerCase()) ? "MT" : "KG"}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      <div className="text-center mt-3">
        <button className="btn btn-success" onClick={saveDetails}>
          Confirm and Submit
        </button>
      </div>
      <div className="text-center mt-3">
        <strong>Note:</strong> Please click on Save button to save the data
        after submitting.
      </div>
    </div>
  );
};

export default TruckDetails;
